import OnwardJourney from './OnwardJourney';

export default OnwardJourney;
